export const hasLongTextButton = (primaryButtonText?: string, secondaryButtonText?: string, maxLength = 25) => {
  const isPrimaryButtonLong = (primaryButtonText?.length || 0) >= maxLength
  const isSecondaryButtonLong = (secondaryButtonText?.length || 0) >= maxLength
  return isPrimaryButtonLong || isSecondaryButtonLong
}
